export default __webpack_public_path__ + "assets/img/blacklist.84ec9ebaf4e7bc456ac9542da71ab034.png";